import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { launchable: Boolean };

  update({ detail: { dirty } }) {
    this.element.disabled = dirty || !this.launchableValue;
  }
}
